import React from 'react'

export const Paragrpah = props => <div className='paragraph'>{props.para}</div>

export default Paragrpah
